<template>
    <Paper>
        <div class="checkImport">
            <el-row>
                <el-col :span='22'>
                    <el-row>
                        <el-col class="checkSearch-item">
                            <el-input v-model="searchData['barcodeNo']" :placeholder="$translate('lang.E2202211100001', { defaultText: '条码字符串' })" @keyup.enter.native="queryBtClick">
                            </el-input>
                        </el-col>
                        <el-col class="checkSearch-item">
                            <el-input v-model="searchData['itemCode']" :placeholder="$translate('lang.E3202201260001', { defaultText: '客户型号' })" @keyup.enter.native="queryBtClick">
                            </el-input>
                        </el-col>
                        <el-col class="checkSearch-item">
                            <el-input v-model="searchData['createUserCode']" :placeholder="$translate('lang.E3202201260002', { defaultText: '创建人' })" @keyup.enter.native="queryBtClick">
                            </el-input>
                        </el-col>
                        <el-col class="checkSearch-btns" >
                            <div class="checkImport-second">
                                <el-button class="page-description-upload" type="primary" :loading="searchLoading" size="mini" @click="queryBtClick">
                                    {{$translate('lang.E3202207280023', { defaultText: '查 询' })}}
                                </el-button>
                                <el-button size="mini" type="primary" @click="batchSearch">{{$translate('lang.E3202301040034', { defaultText: '批量查询导出' })}}</el-button>
                                <el-button class="sn-search-reset-button" @click="restSearchChange" size="mini">{{$translate('lang.E3202207280033', { defaultText: '重 置' })}}</el-button>
                            </div>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="2">
                    <div class="checkImport-btns">
                        <el-button size="mini" type="primary" @click="batchOperation">{{$translate('lang.E3202207280034', { defaultText: '导 入' })}}</el-button>
                        <el-tooltip class="sn-search-default-button" effect="dark" content="Export" placement="bottom">
                            <reportExport #default="{ submit }" reportCode="">
                                <el-button icon="el-icon-upload2" size="mini" @click="searchExport(submit)"></el-button>
                            </reportExport>
                        </el-tooltip>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="closeStyle">
            <m-table ref="RegistrationTable" :pageTotal="pageTotal" :tableData="listData" :currentPage='currentPage' @pageChange="pageChange" @sizeChange="sizeChange" :config="tableConfig">
            </m-table>
        </div>
        <el-dialog title="Uploading files" :visible.sync="dialogVisible" width="600px" :before-close="handleClose">
            <el-upload class="upload-demo" ref="upload" action="" :file-list="fileList" :auto-upload="false" :on-remove="handleRemove" :on-change="fileChange">
                <el-button size="small" type="primary">{{$translate('lang.E3202211100045', { defaultText: '上 传' })}}</el-button>
            </el-upload>
            <el-collapse value='1' class="filesSearch-collapse">
                <el-collapse-item title="Template" name="1">
                    <mExport :url='templateExport.exportUrl' :params='templateExport.exportParams' :name='templateExport.exportName' :type='templateExport.type' :listData='listData' :linkFlag="true"
                        :exportFlag='templateExport.exportFlag' :titleText='templateExport.titleText'>
                    </mExport>
                </el-collapse-item>
            </el-collapse>
            <span slot="footer" class="dialog-footer">
                <reportExport #default="{ submit }" reportCode="">
                    <el-button size="small" @click="uploadFile()" type="primary">{{$translate('lang.E3202211100043', { defaultText: '确 认' })}}</el-button>
                </reportExport>
            </span>
        </el-dialog>
        <el-dialog title="Batch query and export" :visible.sync="dialogVisibleSearch" width="600px" :before-close="handleClose">
            <el-upload class="upload-demo" ref="upload" action="" :file-list="fileList" :auto-upload="false" :on-remove="handleRemove" :on-change="fileChange">
                <el-button size="small" type="primary">{{$translate('lang.E3202211100045', { defaultText: '上 传' })}}</el-button>
            </el-upload>
            <el-collapse value='1' class="filesSearch-collapse">
                <el-collapse-item title="Template" name="1">
                    <mExport :url='SearchExport.exportUrl' :params='SearchExport.exportParams' :name='SearchExport.exportName' :type='SearchExport.type' :listData='listData' :linkFlag="true"
                        :exportFlag='SearchExport.exportFlag' :titleText='SearchExport.titleText'>
                    </mExport>
                </el-collapse-item>
            </el-collapse>
            <span slot="footer" class="dialog-footer">
                <reportExport #default="{ submit }" reportCode="">
                    <el-button size="small" @click="exportFile()" type="primary">{{$translate('lang.E3202211100043', { defaultText: '确 认' })}}</el-button>
                </reportExport>
            </span>
        </el-dialog>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import reportExport from '@/components/lots/reportExportPlugin';
import mExport from '../component/export';
import mTable from '../../../components/IdentityComponent/Main';
import { tableConfig } from './tableConfig.js';
import { dictWithUrl } from '../../../components/basicDataDialog/api';
import {
    sellInUpload,
    searchExport,
    bcBarcodelist,
    bcBarcodeCheck,
    sellInSearch
} from '../../../api/lcbsManagement.js';
const EXPORT_API = '/api-sn/sellIn/searchExport'; // 通用导出接口路径
export default {
    name: 'checkImport',
    components: {
        Paper,
        mExport,
        mTable,
        reportExport
    },
    data() {
        return {
            exportLoading: false,
            inputCheckDisable: false,
            templateExport: {
                exportUrl: '/api-sn/sellIn/getTemplate',
                type: 'get',
                exportName: this.$translate('lang.E3202102220004', {
                    defaultText: 'SN Data Import Template.xls'
                }),
                exportParams: {},
                titleText: this.$translate('lang.E3202202220005', {
                    defaultText: '模板下载'
                }),
                exportFlag: 1
            },
            SearchExport: {
                exportUrl: '/api-sn/sellIn/uploadSearch/getTemplate',
                type: 'get',
                exportName: this.$translate('lang.E3202301040004', {
                    defaultText: 'SN Data Search Template.xls'
                }),
                exportParams: {},
                titleText: this.$translate('lang.E3202202220005', {
                    defaultText: '模板下载'
                }),
                exportFlag: 1
            },
            uploadLoading: false,
            listData: [],
            fileList: [],
            pageTotal: 0,
            currentPage: 1,
            tableConfig,
            searchData: {},
            templateFlie: {},
            batchId: '',
            pageDescription: '',
            entityIdList: [],
            searchLoading: false,
            timeHorizon: [],
            dialogVisible: false,
            dialogVisibleSearch: false
        };
    },
    async created() {
        await this.dictData();
    },
    mounted() {
        this.initData();
        // this.checkUserPermission();
    },
    methods: {
        queryBtClick() {
            this.pageChange(1);
        },
        showDialog() {
            this.dialogVisible = true;
            this.dialogVisibleSearch = true;
        },
        handleClose() {
            this.dialogVisible = false;
            this.dialogVisibleSearch = false;
            this.templateFlie = {};
            this.templateExport.exportFlag = 0;
            this.SearchExport.exportFlag = 0;
            this.$refs.upload.clearFiles();
        },
        batchOperation() {
            this.dialogVisible = true;
        },
        batchSearch() {
            this.dialogVisibleSearch = true;
        },
        queryData() {
            const params = {
                pageNo: this.tableConfig.page.pageNo,
                pageSize: this.tableConfig.page.pageSize,
                ...this.searchData
            };
            if (
                params.barcodeNo === '' &&
                params.itemCode === '' &&
                params.createUserCode === ''
            ) {
                this.$message.warning(
                    this.$translate('lang.EXC202101270005', {
                        defaultText: '请输入查询条件'
                    })
                );
                return false;
            }
            sellInSearch(params).then((res) => {
                if (res.code === '0') {
                    this.listData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                }
            });
        },
        initData() {
            this.searchData = {
                createUserCode: '',
                barcodeNo: '',
                itemCode: ''
            };
            this.templateFlie = {};
            this.fileList = [];
            this.pageTotal = 0;
            this.currentPage = 1;
        },
        handleSearchData() {
            const form = new FormData();
            form.append('file', this.templateFlie.raw);
            // form.append('entityId', this.searchData.entityId);
            return form;
        },
        getBatchId(params) {
            if (
                params.get('file') === 'undefined' ||
                params.get('file') === ''
            ) {
                this.$message.warning(
                    this.$translate('lang.EXC202002220001', {
                        defaultText: '条码上传文件都不能为空！'
                    })
                );
                this.listData = [];
                return;
            }
            this.uploadLoading = true;
            this.exportLoading = true;
            sellInUpload(params).then((res) => {
                    try {
                        const enc = new TextDecoder('utf-8');
                        res = JSON.parse(enc.decode(new Uint8Array(res)));
                        if (+res.code === 0 && +res.data.code === 1) {
                            this.$message.error(res.data.msg);
                        } else {
                            this.$message.success(res.data.msg);
                        };
                    } catch (error) {
                        const blob = new Blob([res], {
                            type: 'application/x-excel;charset=UTF-8'
                        });
                        const objectUrl = URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = objectUrl;
                        a.download = '[sell in date] upload file needs to be adjusted.xls';
                        a.click();
                        this.$message.error(
                            this.$translate('lang.E2202212010001', {
                                defaultText: '导入的文件需要调整'
                            })
                        );
                    };
                })
                .finally(() => {
                    this.uploadLoading = false;
                    this.exportLoading = false;
                });
        },
        getBatchSearch(params) {
            if (
                params.get('file') === 'undefined' ||
                params.get('file') === ''
            ) {
                this.$message.warning(
                    this.$translate('lang.EXC202002220001', {
                        defaultText: '条码上传文件都不能为空！'
                    })
                );
                this.listData = [];
                return;
            }
            this.uploadLoading = true;
            this.exportLoading = true;
            searchExport(params).then(res => {
                if (res.code === '0') {
                    this.$message.success(this.$translate('lang.WARN202301040001', { defaultText: 'The export has been submitted, check back later in the personal files list to download!' }));
                    // this.getList();
                    // this.checkBatchId();
                    // this.queryData();
                }
            }).finally(() => {
                this.uploadLoading = false;
                this.exportLoading = false;
            });
        },
        searchExport(submit) {
            const params = {
                EXPORT_API,
                ...this.searchData
            };
            if (
                params.barcodeNo === '' &&
                params.itemCode === '' &&
                params.createUserCode === ''
            ) {
                this.$message.warning(
                    this.$translate('lang.EXC202101270005', {
                        defaultText: '请输入查询条件'
                    })
                );
                return false;
            }
            if (!this.listData.length) {
                this.$message.warning(
                    this.$translate('lang.EXC202101260002', {
                        defaultText: '暂无导出数据,请重新设置查询条件'
                    })
                );
                return;
            }
            submit(params);
        },
        getList() {
            if (!this.batchId) {
                this.$message.warning(
                    this.$translate('lang.EXC202002220002', {
                        defaultText: '请先上传条码盘点获取批次号'
                    })
                );
                return;
            }
            const params = {
                pageNo: this.tableConfig.page.pageNo,
                pageSize: this.tableConfig.page.pageSize,
                batchId: this.batchId
            };
            bcBarcodelist(params).then((res) => {
                if (res.code === '0') {
                    this.listData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                }
            });
        },
        checkBatchId() {
            if (!this.batchId) {
                this.$message.warning(
                    this.$translate('lang.EXC202002220002', {
                        defaultText: '请先上传条码盘点获取批次号'
                    })
                );
                return;
            }
            const params = {
                batchId: this.batchId,
                entityId: this.searchData.entityId
            };
            bcBarcodeCheck(params).then((res) => {
                if (res.code === '0') {
                    this.$message.success(
                        this.batchId +
                            this.$translate('lang.EXC202002220004', {
                                defaultText: '批次号盘点成功'
                            })
                    );
                }
            });
        },
        uploadFile() {
            const params = this.handleSearchData();
            this.getBatchId(params);
            this.handleClose();
        },
        exportFile() {
            const params = this.handleSearchData();
            this.getBatchSearch(params);
            this.handleClose();
        },
        restSearchChange() {
            this.initData();
        },
        handleRemove(file) {
            this.templateFlie = {};
            this.fileList = [];
            this.$refs.upload.clearFiles();
        },
        fileChange(file, fileList) {
            if (this.exportLoading) {
                return;
            }
            if (fileList) {
                this.fileList = [fileList[fileList.length - 1]];
            }
            const testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
            if (testmsg !== 'xls' && testmsg !== 'xlsx') {
                this.$message.warning(
                    this.$translate('lang.EXC202002220005', {
                        defaultText: '表格上传类型不正确,请上传xls,xlsx文件'
                    })
                );
                this.$refs.upload.clearFiles();
                this.templateFlie = {};
                this.fileList = [];
            } else {
                this.templateFlie = file;
            }
        },
        pageChange(pageNo) {
            this.tableConfig.page.pageNo = pageNo;
            this.currentPage = pageNo;
            // this.getList();
            // const params = this.handleSearchData();
            this.queryData();
        },
        sizeChange(pageSize) {
            this.tableConfig.page.pageNo = 1;
            this.tableConfig.currentPage = 1;
            this.tableConfig.page.pageSize = pageSize;
            // this.getList();
            this.queryData();
        },
        async dictData() {
            const option = await dictWithUrl('BILL_DESC,BCPARSING_ENTITY_ID'); // BILL_DESC-菜单描述
            const dictOptions = {};
            if (+option.code === 0) {
                const dictList = option.data.BILL_DESC;
                this.entityIdList = option.data.BCPARSING_ENTITY_ID;
                dictList.forEach((item) => {
                    dictOptions[item.code] = item.name;
                });
            }
            this.pageDescription = dictOptions[this.$options.name].replace(
                / {2}/g,
                '\n'
            );
        }
    }
};
</script>
<style lang="less" src='./index.less'>
</style>
